import styles from './FundingHeader.module.css';

const FundingHeaderLoading = () => {
    return (
        <div data-testid="funding-header-loading">
            <div className={styles.fundingHeaderLoading}></div>
            <div className={styles.fundingSubHeaderLoading}></div>
        </div>
    );
};
// eslint-disable-next-line import/no-default-export
export default FundingHeaderLoading;
